import { NgModule } from '@angular/core';
import { AddressComponent } from './address/address.component';
import { BranchOperationComponent } from './branch-operation/branch-operation.component';
import { DocumentComponent } from './document/document.component';
import { EntityOwnerComponent } from './entity-owner/entity-owner.component';
import { NotesComponent } from './notes/notes.component';
import { OfficeHoursComponent } from './office-hours/office-hours.component';
import { SharedModule } from '@shared';
import { PaymentsModule } from '../payments/paymentsmodule';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { MY_DATE_FORMATS, MY_DATE_ADAPTER } from '../in-home-care/license-date-format';
import { CommunicationLogsComponent } from './communication-logs/communication-logs.component';
import { AuditLogComponent } from './audit-log/audit-log.component';
import { EntityTaskComponent } from './entity-task/entity-task.component';
import { ApplicantInformationComponent } from './applicant-information/applicant-information.component';
import { ComplaintComponent } from './compliance/complaint/complaint.component';
import { AffectedPersonDialogComponent } from './compliance/affected-person/dialog-affected-person.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AllegationComponent } from './compliance/allegation/allegation.component';

const COMPONENTS = [
  AddressComponent,
  DocumentComponent,
  NotesComponent,
  EntityOwnerComponent,
  BranchOperationComponent,
  OfficeHoursComponent,
  CommunicationLogsComponent,
  AuditLogComponent,
  EntityTaskComponent,
  ApplicantInformationComponent,
  ComplaintComponent,
  AllegationComponent,
  AffectedPersonDialogComponent
];

@NgModule({
  declarations: [...COMPONENTS],
  imports: [
    NgxMaskDirective,
    NgxMaskPipe,
    SharedModule,
    PaymentsModule,
    MatFormFieldModule,
    MatInputModule
  ],
  exports: [
    ...COMPONENTS
  ],
  providers: [
    provideNgxMask(),
    { provide: MAT_DATE_LOCALE, useValue: 'en-US' },
    MY_DATE_FORMATS,
    MY_DATE_ADAPTER
  ]
})
export class ReusableModule { }
